export default __webpack_public_path__ + "static/media/logo_GMX.18d2594f.svg";